<template>

	<v-dialog
		v-model="visible"
		:max-width="width"
		:height="height"
		persistent
		:overlay-opacity="overlayOpacity">

		<v-card
			class="pt-2 pb-4 success-bg">

			<v-card-title>{{ dialogTitle }}</v-card-title>

        	<v-card-text v-html="message"></v-card-text>

			<v-card-actions>
         	<v-spacer></v-spacer>

				<!-- Tasto OK (Conferma e Chiusura) -->
				<v-btn
					text
					@click="onOk">
					{{ dialogOkText }}
				</v-btn>
        	</v-card-actions>

      	</v-card>
	</v-dialog>
  
</template>

<style>

</style>

<script>
import { EventBus } from '@/components/EventBus.js';
const { Utils } = require('@/assets/js/scripts/utils/Utils.js');

export default {
	name: 'dialog-success',
	props: {

	},

	created() {
		EventBus.$on('open_dialog_success', (dialog) => {
			this.open(dialog);
		});

		EventBus.$on('close_dialog_success', () => {
			this.close();
		});
	},

	data: () => ({
		visible: false,
		width: 400,
		height: 200,

		overlayOpacity: 0.5,

		message: null,
		dialogTitle: 'Informazioni',

		dialogOkText: 'Ok',

		// Event open/close counter
		openEventCount: 0,
		closeEventCount: 0
	}),

	methods: {
		setDialog: function(dialog) {
			if(typeof dialog === "undefined") {
				return;
			}

			// Imposta il messaggio
			if(dialog.message) {
				this.message = dialog.message;
			}

			//Override titolo se specificato
			if(dialog.title) {
				this.dialogTitle = dialog.title;
			}

			// Imposta eventuale opacità di overflow
			if(!Utils.isNullOrUndefined(dialog.overlayOpacity) && parseFloat(dialog.overlayOpacity) != "NaN") {
				this.overlayOpacity = parseFloat(dialog.overlayOpacity);
			}

			if(dialog.actions) {
				if(typeof dialog.actions.onSuccess === 'function') {
					this.onSuccessCallback = dialog.actions.onSuccess;
				}
			}
		},

		resetEventsCount: function() {
			this.openEventCount = 0;
			this.closeEventCount = 0;
		},

		open: function(dialog) {
			this.openEventCount++;
			this.setDialog(dialog);
			this.visible = true;
		},

		close: function() {
			this.onSuccessCallback = null;
			this.closeEventCount++;
	
			if(this.closeEventCount >= this.openEventCount) {
				this.visible = false;
				this.resetEventsCount();
			}
		},

		onOk: function() {
			if(typeof this.onSuccessCallback === "function") {
				this.onSuccessCallback();
			}
			this.close();
		}
	}
}
</script>